<template>
    <div class="adminPage">
        <b-row class="pageTitle">
            <b-col cols="12" class="d-flex mb-3">
                <h3 class="m-0">Quản trị viên</h3>
                <b-button size="sm" variant="primary" class="ml-2" :to="{path:'/admin/new'}" @click="trackingNewAdmin()">Tạo mới</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <transition name="slide">
                    <b-card>
<!--                        <div slot="header">-->
<!--                            <b-row align-h="between">-->
<!--                                <b-col cols="6">-->
<!--                                    <b-button-group>-->
<!--                                        <b-dropdown variant="outline-primary" left :text="actions[action]">-->
<!--                                            <b-dropdown-item v-for="(act,index) in actions" @click="action = index" :key="index">{{act}}</b-dropdown-item>-->
<!--                                        </b-dropdown>-->
<!--                                        <b-button variant="primary" @click="runAction">Thực hiện</b-button>-->
<!--                                    </b-button-group>-->
<!--                                </b-col>-->
<!--                                <b-col cols="6" class="justify-content-end d-flex">-->
<!--                                    <div class="search-area">-->
<!--                                        <b-form @submit="searchForm" class="justify-content-end d-flex">-->
<!--                                            <b-form-select v-model="filter.status" :options="filter.statusArr" class="mr-2"></b-form-select>-->
<!--                                            <b-input-group class="mb-0">-->
<!--                                                <b-form-input v-model="filter.search" placeholder="Tìm kiếm"></b-form-input>-->
<!--                                                <b-input-group-append>-->
<!--                                                    <b-button size="sm" text="Button" variant="primary" type="submit" >-->
<!--                                                        <i class="icon-magnifier icons font-lg  pl-1 pr-1"></i>-->
<!--                                                    </b-button>-->
<!--                                                </b-input-group-append>-->
<!--                                            </b-input-group>-->
<!--                                        </b-form>-->
<!--                                    </div>-->
<!--                                </b-col>-->
<!--                            </b-row>-->

<!--                        </div>-->
                        <div v-if="pages && pages.rows" :class="{'ptt-loading':loading}">

                            <b-table bordered responsive="sm" :items="pages.rows" :fields="fields" :hover="true">
                                <template slot="HEAD_checked" slot-scope="data">
                                    <b-form-checkbox v-model="selectAll" @change="selectAllToggle()"/>
                                </template>
                                <template slot="checked" slot-scope="option">
                                    <b-form-checkbox v-model="selected" :value="option.item._id"/>
                                </template>
                                <template slot="fullName" slot-scope="option">
                                    {{option.value}}
                                </template>
                                <template slot="group" slot-scope="option">
                                   {{ (option.item.adminGroup && option.item.adminGroup[0]) ? option.item.adminGroup[0].title : "N/A"}}
                                </template>

                                <template slot="status" slot-scope="option">
                                    <b-badge class="p-2" pill variant="success" v-if="option.item.status === 1">Đang hoạt động</b-badge>
                                    <b-badge class="p-2" pill variant="danger" v-if="option.item.status === 2">Ngừng hoạt động</b-badge>
                                    <b-badge class="p-2" pill variant="warning" v-if="option.item.status === 3">Tạm khóa</b-badge>
                                </template>

                              <template slot="action" slot-scope="option">
                                <b-link :to="{ path: '/admin/' + option.item._id}">
                                  <b-button variant="primary" size="sm" class="m-1">
                                    <i class="cui-pencil"></i>
                                    Sửa
                                  </b-button>
                                </b-link>
                              </template>

                            </b-table>
                            <nav v-if="pages && pages.totalPages > 1">
                                <b-pagination :total-rows="pages.count" :per-page="limit" v-model="pages.page"/>
                            </nav>
                        </div>

                        <div :class="{'ptt-loading':loading}" v-else>
                            <b-alert show variant="warning">Không có tài khoản</b-alert>
                        </div>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>

</template>

<script>
import {isAuth, isSuperAdmin} from "@/utils/auth";
import axios from "axios";

export default {
  name: 'AdminList',
  data: () => {
    return {
      data: [],
      pages: {
        page: 1
      },
      limit: 20,
      action: 0,
      actions: [
        "Hành động",
        "Xóa các lựa chọn"
      ],
      fields: [
        {key: "fullName", label: "Tên", thStyle: "width: 320px"},
        {key: "email", label: "Email"},
        {key: "createdAt", label: "tg. khởi tạo", thStyle: "width: 150px;" , formatter: "getDate"},
        {key: "status", label: "Trạng thái", thStyle: "width: 100px;"},
        {key: "action", label: "", align: "right", thStyle: "width: 140px;"},
      ],
      selected: [],
      selectAll: false,
      loading: false,
      filter: {
        search: '',
        status: null,
        statusArr: [
          {value: null, text: 'Tất cả'},
          {value: 1, text: 'Đang hoạt dộng'},
          {value: 2, text: 'Ngừng hoạt động'},
        ]
      },
      q: {}

    }
  },
  computed: {
  },
  watch: {

  },
  mounted() {
    if (!isAuth() || !isSuperAdmin()) {
      this.$router.push('/login')
    }
    this.fetchData()
  },
  created() {

  },
  methods: {
    async fetchData(page = null) {
      try {
        this.loading = true
        const token = this.$cookies.get('token');
        let params = {
          sort: '-createdAt',
        }
        if (page > 0) {
          params.page = page
        }
        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data} = await axios.get(this.$configs.api + '/api/v4/cp/admin', {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params
        });

        if (data) {
          this.pages = data
        }
        if (data && data.rows) {
          this.data = data.rows
        }
        if (data && data.totalPages) {
          this.pages.count = data.totalPages
        }

        const user = this.$cookies.get('user');
        this.$gtag.event('get_admin_list', {
          event_category: 'admin_events',
          event_label: 'List administrators',
          user_type: 'admin',
          user_id: user?._id,
          qs: JSON.stringify(params) || null,
          result: {
            total: data?.total
          }
        });

      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    getDate(date){
      return this.$moment(date).format('MM-DD-YYYY H:m')
    },
    trackingNewAdmin() {
      const user = this.$cookies.get('user');
      this.$gtag.event('click_new_admin', {
        event_category: 'click_events',
        event_label: 'New admin button',
        user_type: 'admin',
        user_id: user?._id,
      });
    }

  }
}
</script>
